import React, { FC } from "react";

import { CheckCircleIcon } from "@/assets/icons";

import { StyledCheckCircleContainer, StyledCheckCircleLabel } from "./styled";

type CheckedItemProps = {
    title: string | React.ReactElement;
    style?: React.CSSProperties;
    disabled?: boolean;
};

const CheckedItem: FC<CheckedItemProps> = ({ title, disabled = false, style }) => {
    return (
        <StyledCheckCircleContainer style={style} $disabled={disabled}>
            <CheckCircleIcon className="checkCircle" />
            <StyledCheckCircleLabel>{title}</StyledCheckCircleLabel>
        </StyledCheckCircleContainer>
    );
};

export default CheckedItem;
